export const forEntity = (entity)=>{
    return {
        encode: (destination: string) => {
            return encode(destination, entity)
        },
        id: (destination: string) => {
            return id(destination, entity)
        },

    }
}

export const encode = (destination, entity:string = null)=>{

    if(!destination){
        return null
    }

    if(!entity && destination.entity){
        entity = destination.entity
    }

    if(!entity && !destination.entity){
        entity = "harbour"
    }

    if(entity == 'Harbour'){
        entity = "harbour"
    }
    if(entity == 'Country'){
        entity = "country"
    }
    if(entity == 'Region'){
        entity = "region"
    }
    if(entity == 'Location'){
        entity = "location"
    }

    const ret =  {"value": entity+":" + destination.id, "label": destination.name, "entity": entity}
    return ret

}

export const id = (destination, entity:string = null)=>{

    if(!destination){
        return null
    }

    if(!entity && destination.entity){
        entity = destination.entity
    }

    if(!entity && !destination.entity){
        entity = "harbour"
    }

    if(entity == 'Harbour'){
        entity = "harbour"
    }
    if(entity == 'Country'){
        entity = "country"
    }
    if(entity == 'Region'){
        entity = "region"
    }
    if(entity == 'Location'){
        entity = "location"
    }

    const ret =  entity+":" + destination.id

    return ret

}

